"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.References = void 0;
class References {
    constructor(path = ["#"], items = [], $refStrategy = "root", effectStrategy = "input", target = "jsonSchema7", propertyPath = []) {
        this.currentPath = path;
        this.items = items;
        this.$refStrategy = $refStrategy;
        this.effectStrategy = effectStrategy;
        this.target = target;
        this.propertyPath = propertyPath;
    }
    addToPath(...path) {
        return new References([...this.currentPath, ...path], this.items, this.$refStrategy, this.effectStrategy, this.target, this.propertyPath);
    }
    addToPathAsProperty(...path) {
        return new References([...this.currentPath, ...path], this.items, this.$refStrategy, this.effectStrategy, this.target, [...this.currentPath, ...path]);
    }
}
exports.References = References;
